/**
 * Der komplette sichtbare Einladungstext. Nur diese Datei bearbeiten, um den
 * Bannerinhalt zu ändern; Zeilenumbrüche werden genauso im Banner dargestellt.
 */
// Bearbeite nur diesen Text: Zeilenumbrüche werden im Banner genau so übernommen.
export const invitationBannerText = `LEVEL 7 FREIGESCHALTET

[b]{{anrede}}[/b]

[b]HENRY WIRD 7[/b]

DU BIST EINGELADEN ZUM
SUPER-MARIO-GEBURTSTAG!

[left]DATUM:   [b]06.09.2026[/b]
[left]UHRZEIT: [b]12:00 bis 16:00 UHR[/b]
[left]ORT:     [b]IM BREITEN FELD 20[/b]

LASS UNS GEMEINSAM SPIELEN
UND PEACH BEFREIEN!
LIEBE GRÜßE, [b]HENRY[/b]

Bitte sag mir unter 0170 9245785 
Bescheid, ob du kommst.`;

